module.exports = __webpack_public_path__ + "static/media/ganesh.117d32f1.png";